// @ts-nocheck
/* eslint-disable */
import type { HistoryServiceV2 } from '@feature-hub/history-service';
import React from 'react';

export type HistoryState = {
  historyService: HistoryServiceV2 | null;
};

export const defaultState: HistoryState = {
  historyService: null,
};

export type State = {
  historyService: HistoryServiceV2 | null;
};

export const historyStateContext = React.createContext<State | null>(null);

const Provider = ({
  children,
  historyService,
}: {
  children: React.ReactNode;
  historyService?: HistoryServiceV2;
}) => {
  const [state] = React.useState({
    ...defaultState,
    historyService: historyService,
  });

  return <historyStateContext.Provider value={state}>{children}</historyStateContext.Provider>;
};

function useHistoryState() {
  const context = React.useContext(historyStateContext);
  if (!context) {
    throw new Error('useHistoryState must be used within a Provider');
  }
  return context;
}

export default { Provider, useHistoryState };
